import { IconButton, IconButtonProps } from '@makyoapp/makyo-tw-ui'

export type CompIconButtonProps = IconButtonProps

export const CompIconButtonCore = IconButton
